import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';
import { ISubscriber } from '../../private/dashboard/modal-newsletter/ipagination-newsletter.model';

@Injectable()
export class NewsletterService {

  constructor(private apiService: ApiService) { }

  all(): Observable<ISubscriber[]> {
    return this.apiService.get('/gandadmin/subscribers');
  }

  find(params: DataTableParams) {
    return this.apiService.post('/gandadmin/subscribers/find', params);
  }
}
